module.exports = __webpack_public_path__ + "img/casa2.fd7ac780.jpeg";